import { render, staticRenderFns } from "./OTCCoinSelect.vue?vue&type=template&id=0f4c4dbb&scoped=true&"
import script from "./OTCCoinSelect.vue?vue&type=script&lang=js&"
export * from "./OTCCoinSelect.vue?vue&type=script&lang=js&"
import style0 from "./OTCCoinSelect.vue?vue&type=style&index=0&id=0f4c4dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c4dbb",
  null
  
)

export default component.exports